"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _lodash = require("lodash");

var _LoadingSpinner = _interopRequireDefault(require("../LoadingSpinner"));

require("./button.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Button = _react.default.forwardRef(function (props, ref) {
  var className = props.className,
      variant = props.variant,
      color = props.color,
      label = props.label,
      children = props.children,
      disabled = props.disabled,
      isLoading = props.isLoading,
      active = props.active,
      borderRadius = props.borderRadius,
      rest = _objectWithoutProperties(props, ["className", "variant", "color", "label", "children", "disabled", "isLoading", "active", "borderRadius"]);

  var variableClassName, spinnerBackground, spinnerColor;
  var borderRadiusClassName = (0, _lodash.isEmpty)(borderRadius) ? 'rounded' : "rounded-".concat(borderRadius);

  if (variant === 'solid') {
    var solidClassName = "py-2 px-4 border ".concat(borderRadiusClassName);

    if (color === 'primary') {
      spinnerBackground = 'bg-primary';
      spinnerColor = '#FFFFFF';
      variableClassName = (0, _classnames.default)(solidClassName, 'text-gray-100 bg-primary border-primary');
    } else if (color === 'secondary') {
      spinnerBackground = 'bg-gray-200';
      spinnerColor = '#4A5568';
      variableClassName = (0, _classnames.default)(solidClassName, 'bg-gray-200 text-gray-800');
    } else if (color === 'default') {
      spinnerBackground = 'bg-white';
      spinnerColor = '#A0AEC0';
      variableClassName = (0, _classnames.default)(solidClassName, 'bg-white text-black');
    } else if (color === 'inverted') {
      spinnerBackground = 'bg-white';
      spinnerColor = '#A0AEC0';
      variableClassName = (0, _classnames.default)(solidClassName, 'bg-white');
    } else {
      spinnerBackground = "bg-".concat(color);
      spinnerColor = '#FFFFFF';
      variableClassName = (0, _classnames.default)(solidClassName, "bg-".concat(color, " border-").concat(color, " text-white"));
    }
  } else if (variant === 'outlined') {
    var outlinedClassName = "py-2 px-4 bg-transparent border ".concat(borderRadiusClassName);

    if (color === 'primary') {
      spinnerBackground = 'bg-white';
      variableClassName = (0, _classnames.default)(outlinedClassName, 'text-primary border-primary');
    } else if (color === 'secondary') {
      spinnerColor = '#4A5568';
      spinnerBackground = 'bg-gray-200';
      variableClassName = (0, _classnames.default)(outlinedClassName, 'text-gray-800 bg-gray-200');
    } else if (color === 'inverted') {
      spinnerBackground = 'bg-white';
      spinnerColor = '#A0AEC0';
      variableClassName = (0, _classnames.default)(outlinedClassName, 'text-white');
    } else {
      spinnerBackground = 'bg-white';
      variableClassName = (0, _classnames.default)(outlinedClassName, "text-".concat(color, " border-").concat(color));
    }
  } else if (variant === 'text') {
    spinnerBackground = 'bg-transparent';

    if (color === 'primary') {
      variableClassName = 'text-primary';
    } else if (color === 'secondary') {
      spinnerColor = '#4A5568';
      variableClassName = 'text-secondary';
    } else {
      variableClassName = "text-".concat(color);
    }
  }

  var computedClassName = (0, _classnames.default)(className, variableClassName, 'button relative overflow-hidden no-underline', {
    'opacity-75 cursor-auto': disabled,
    'bg-primary-lightest text-primary border border-primary': active
  });
  var spinnerClassName = (0, _classnames.default)('absolute inset-0 flex justify-center items-center', spinnerBackground);
  return _react.default.createElement("button", _extends({
    ref: ref,
    className: computedClassName,
    disabled: disabled
  }, rest), isLoading && _react.default.createElement("div", {
    className: spinnerClassName
  }, _react.default.createElement(_LoadingSpinner.default, {
    size: 24,
    color: spinnerColor
  })), label || children);
});

Button.propTypes = {
  variant: _propTypes.default.oneOf(['solid', 'outlined', 'text']),
  color: _propTypes.default.string,
  // Main colors are 'primary', 'secondary', 'default', 'inverted'
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  children: _propTypes.default.node,
  active: _propTypes.default.bool,
  borderRadius: _propTypes.default.string
};
Button.defaultProps = {
  color: 'primary',
  variant: 'solid',
  label: '',
  children: null,
  active: false,
  borderRadius: 'full'
};

var _default = _react.default.memo(Button);

exports.default = _default;